import * as React from "react";
// import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
// import { Button } from '@progress/kendo-react-buttons';
export const CommandCell = (props) => {
  const { dataItem } = props;
  const inEdit = dataItem[props.editField];
  const [visible, setVisible] = React.useState(false);
  // const onDeleteData = () => {
  //   props.remove(props.dataItem);
  //   setVisible(!visible);
  // };
  // const toggleDialog = () => {
  //   setVisible(!visible);
  // };
  return (
    <td className="k-command-cell">
      <div className="flex items-center gap-2">
        <button
          title={inEdit ? "Save row" : "Edit"}
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded border border-gray-400 disabled:cursor-not-allowed disabled:opacity-40"
          disabled={inEdit ? props.validate(dataItem) : false}
          onClick={() =>
            inEdit ? props.update(dataItem) : props.edit(dataItem)
          }
        >
          {inEdit ? (
            <img src="tickIcon.svg" className="h-4" />
          ) : (
            <img src="editIcon.svg" className="h-4" />
          )}
        </button>
        <button
          title={inEdit ? "Discard changes" : "Delete"}
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded border border-gray-400"
          onClick={() =>
            inEdit ? props.discard(dataItem) : props.remove(dataItem)
          }
        >
          {inEdit ? (
            <img src="closeIcon.svg" className="h-4" />
          ) : (
            <img src="deleteIcon.svg" className="h-4" />
          )}
        </button>
      </div>
    </td>
  );
};
